'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaults = require('../defaults');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaults.DEFAULT_TIMEZONE;
  return state;
};
//# sourceMappingURL=timezone.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-global-settings/dist/main/reducers/timezone.js
// module id = 523
// module chunks = 0